export default __webpack_public_path__ + "static/media/cryptonews_logo.40285404.svg";